import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';

import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CoreModule} from './core/core.module';
import {AngularMaterialModule} from './angular-material/angular-material.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {LoaderInterceptor} from './interceptors/loader.interceptor';
import {AuthInterceptor} from './interceptors/auth.interceptor';
import {ErrorInterceptor} from './interceptors/error.interceptor';
import {SharedModule} from './shared/shared.module';
import {MessageService} from './shared/services/message.service';
import {AdminModule} from './admin/admin.module';
import {KfDataEntryModule} from './kf-data-entry/kf-data-entry.module';
import {KfReportingModule} from './kf-reporting/kf-reporting.module';
import {IntelligenceReportingModule} from './intelligence-reporting/intelligence-reporting.module';
import {KfChartsModule} from './kf-charts/kf-charts.module';
import {IntelligenceDataEntryModule} from './intelligence-data-entry/intelligence-data-entry.module';
import {IntelligenceModule} from './intelligence/intelligence.module';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
        }),
        CoreModule,
        AngularMaterialModule,
        DashboardModule,
        FlexLayoutModule,
        SharedModule,
        AdminModule,
        IntelligenceModule,
        IntelligenceReportingModule,
        IntelligenceDataEntryModule,
        KfDataEntryModule,
        KfReportingModule,
        KfChartsModule,
    ],
  exports: [
    AngularMaterialModule,
    CoreModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('en');
    translate.use('en');
  }
}
